import {ExpandingButtonsStateProps} from '../../src/components/ChatAndPlayerListPanel';

export function isUserPressingActiveButton(buttonTitle: string, expandingButtonsState: ExpandingButtonsStateProps) {
    if (
        (buttonTitle === 'CHAT' && expandingButtonsState.chat) ||
    (buttonTitle === 'PLAYERS' && expandingButtonsState.players)
    ) {
        return true;
    }
    return false;
}